import React, { useEffect } from 'react'

import { Link, useNavigate } from 'react-router-dom'

import { Result } from './Result/Result'
import style from './Review.module.css'
import { ReviewTable } from './ReviewTable/ReviewTable'

import BannerAvif from 'assets/images/banner-improve-results.avif'
import Banner from 'assets/images/banner-improve-results.jpg'
import { Button } from 'common/components'
import { useAppDispatch, useAppSelector, useKeyDown } from 'common/hooks'
import { Paths } from 'common/routes'
import { Task } from 'common/types/entities'
import { shuffleArray, startConfetti } from 'common/utils'
import { setResult } from 'features/dashboard'
import { resetExam, setTasks } from 'features/exam'

type PropsType = {
  testId: string
  tasks: Task[]
}

export const Review = ({ testId, tasks }: PropsType) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const results = useAppSelector(state => state.exam.results)

  const rightAnswersQuantity = results.filter(result => result.status === true).length
  const resultPercent = Math.floor((100 * rightAnswersQuantity) / results.length)

  useEffect(() => {
    dispatch(
      setResult({
        id: testId,
        result: resultPercent,
      })
    )
  }, [])

  useEffect(() => {
    if (resultPercent === 100) {
      startConfetti()
    }
  }, [resultPercent])

  useKeyDown(() => navigate(Paths.Info), 'Enter')

  const restartExam = () => {
    dispatch(resetExam())
    dispatch(setTasks(shuffleArray(tasks)))
  }

  return (
    <div>
      <Result
        answersQuantity={results.length}
        rightAnswersQuantity={rightAnswersQuantity}
        resultPercent={resultPercent}
      />

      {resultPercent !== 100 && <ReviewTable results={results} tasks={tasks} />}

      <div className={style['button-box']}>
        {resultPercent !== 100 && (
          <Button type="button" onClick={restartExam}>
            Пройти заново
          </Button>
        )}
        <Button type="button" onClick={() => navigate(Paths.Info)} accent>
          Выбрать тест
        </Button>
      </div>

      <Link
        to={'https://it-incubator.io/?utm_source=lending&utm_medium=interview_q&utm_campaign=test'}
        target="_blank"
        className={style.Banner}
      >
        <picture>
          <source srcSet={BannerAvif} type="image/avif" />
          <img
            src={Banner}
            alt="Хочешь улучшить результат и найти работу? Приходи в IT-инкубатор, мы обучаем до трудоустройства"
          />
        </picture>
      </Link>
    </div>
  )
}
